import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, ProtectedRoute } from "./auth";
import LandingPage, { DraftPreview } from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage/>}/>
          <Route path="/login" element={<LoginPage/>}/>
          <Route path="/admin" element={<ProtectedRoute><AdminPage/></ProtectedRoute>}/>
          <Route path="/preview/draft" element={<ProtectedRoute><DraftPreview/></ProtectedRoute>}/>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
        <Toaster position="bottom-right" richColors/>
      </BrowserRouter>
    </AuthProvider>
  );
}
